import React from "react";
import SigninRegisterModal from "../../components/modal/signin-register-modal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Virtual } from "swiper/modules";
import "swiper/css";
import "swiper/css/virtual";
import AppFooterWeb from "../../components/AppFooterWeb";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectThingData,
  selectemployeeData,
} from "../../store/home/home.selectors";
import {
  thingSyncStart,
  resetThings,
  updateHomeSlideId,
} from "../../store/home/home.actions";
import AppConfig from "../../config/app.config";
import Banner from "../../components/banners/Banner";
import { Backdrop, CircularProgress } from "@mui/material";

const mapStateToProps = (state) => {
  return {
    thingData: selectThingData(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      thingSyncStart,
      resetThings,
      updateHomeSlideId,
    },
    dispatch
  ),
});

export class ThingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      isSigninRegisterModalVisible: false,
      thingList: null,
      label: "",
    };
    this.swiper = null;
  }

  filters = {
    amps: { thingSubTypeId: 102639 },
    photos: { thingSubTypeId: 102652 },
    posters: { thingSubTypeId: 102644 },
    tshirts: { thingSubTypeId: 102641 },
    instruments: { thingTypeId: 1319678 },
    liveaid: { thingSubTypeId: 102638 },
  };

  titles = {
    amps: "Amps",
    photos: "Photos",
    posters: "Posters",
    tshirts: "T Shirts",
    instruments: "Instruments",
    liveaid: "Live Aid",
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { thingSyncStart } = this.props;
    const thingName = this.props.match.params.thingName;
    const artistId = this.props.match.params.artistId;
    var payload = {
      appId: AppConfig.API.APP_ID,
      subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
      verticalId: AppConfig.API.VERTICAL_ID,
      loginEmployeeId: this.props.employeeData?.employeeId,
      timeZone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
    };
    if (
      thingName == null &&
      this.props.location?.pathname.startsWith("/artists")
    ) {
      payload = {
        ...payload,
        artistId: artistId,
      };
    } else {
      payload = {
        ...payload,
        ...this.filters[thingName],
      };
    }
    this.props.updateHomeSlideId(null);
    thingSyncStart(payload);
    this.setState({
      isLoading: 1,
      label: Object.keys(this.titles).includes(thingName)
        ? this.titles[thingName]
        : "",
    });
  }

  componentWillUnmount() {
    this.swiper = null;
    this.props.resetThings();
    this.props.updateHomeSlideId(null);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { thingData } = this.props;
    if (thingData.thingList !== prevProps.thingData.thingList) {
      if (
        !thingData.syncingThing &&
        this.state.thingList !== thingData.thingList
      ) {
        var label = this.state.label;
        if (
          this.props.location?.pathname.startsWith("/artists") &&
          thingData.thingList != null &&
          thingData.thingList.length > 0
        ) {
          label = thingData.thingList[0]?.artistName ?? "";
        }
        this.setState(
          {
            thingList: thingData.thingList,
            label: label,
            isLoading: 0,
          },
          () => {
            if (this.swiper != null) {
              const projectId =
                this.state.thingList[this.swiper.activeIndex]?.projectId;
              this.props.updateHomeSlideId(
                projectId === "" ? null : projectId ?? null
              );
            }
          }
        );
      }
    }
    if (thingData.syncingThing !== prevProps.thingData.syncingThing) {
      this.setState({
        isLoading: thingData.syncingThing ? 1 : 0,
      });
    }
  }

  render() {
    return (
      <div className="banner-section title-section">
        {this.state.isLoading === 1 && (
          <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <div className="add-pagetitle">
          <p>{this.state.label}</p>
        </div>
        <Swiper
          autoHeight={true}
          direction={"vertical"}
          spaceBetween={0}
          mousewheel={{
            releaseOnEdges: true,
          }}
          virtual={{
            enabled: true,
            addSlidesAfter: 3,
            addSlidesBefore: 3,
          }}
          modules={[Mousewheel, Virtual]}
          className="mySwiper"
          onSwiper={(swiper) => {
            this.swiper = swiper;
            if (this.state.favoriteList != null) {
              const projectId =
                this.state.favoriteList[swiper.activeIndex]?.projectId;
              this.props.updateHomeSlideId(
                projectId === "" ? null : projectId ?? null
              );
            }
          }}
          id="swiperheader"
          onSlideChange={(swiper) => {
            const projectId =
              this.state.thingList[swiper.activeIndex]?.projectId;
            this.props.updateHomeSlideId(
              projectId === "" ? null : projectId ?? null
            );
          }}
        >
          {this.state.thingList != null &&
            this.state.thingList.map((banner, index) => {
              return (
                <SwiperSlide
                  className={index % 2 === 0 ? "left-banner" : "right-banner"}
                  key={banner.projectId}
                  virtualIndex={index}
                >
                  <Banner
                    bannerData={banner}
                    showSigninRegisterModal={() =>
                      this.setState({ isSigninRegisterModalVisible: true })
                    }
                  />
                </SwiperSlide>
              );
            })}
          <SwiperSlide
            className="hide-footersection"
            key={-1}
            virtualIndex={
              this.state.thingList != null
                ? this.state.thingList.length === 0
                  ? 0
                  : this.state.thingList.length + 1
                : 0
            }
          >
            <AppFooterWeb
              pathName={this.props.location?.pathname}
              history={this.props.history}
            />
          </SwiperSlide>
        </Swiper>
        <SigninRegisterModal
          show={this.state.isSigninRegisterModalVisible}
          hideModal={() =>
            this.setState({ isSigninRegisterModalVisible: false })
          }
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThingList);
